import { bookServiceApi } from '@/services/api';

export interface Character {
  character_id: number;
  name: string;
  description: string;
  icon: string;
}

export interface CharactersResponse {
  characters: Character[];
}

/**
 * Get characters for a specific book (novel)
 * @param bookId - The book ID
 */
export const getBookCharacters = async (bookId: number): Promise<CharactersResponse> => {
  if (!bookId) {
    throw new Error('Book ID is required');
  }

  try {
    const response = await bookServiceApi.get<CharactersResponse>(`/novel/books/${bookId}/characters`);

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.error || 'Failed to fetch book characters');
  } catch (error) {
    console.error(`Error fetching characters for book ${bookId}:`, error);
    throw new Error('Failed to fetch book characters. Please try again later.');
  }
};
